import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import { useCart } from "@/hooks/useCart";
import { PRODUCTS, scrollToSection } from "@/data/products";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Categories from "@/components/Categories";
import About from "@/components/About";
import Products from "@/components/Products";
import ProductModal from "@/components/ProductModal";
import HowToOrder from "@/components/HowToOrder";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function App() {
  const cart = useCart();
  const [cartOpen, setCartOpen] = useState(false);
  const [activeProduct, setActiveProduct] = useState(null);
  const [category, setCategory] = useState("All Products");
  const [condition, setCondition] = useState("All Conditions");

  const addToCart = (id) => {
    cart.add(id);
    const product = PRODUCTS.find((p) => p.id === id);
    toast.success("Added to cart", {
      description: product ? product.name : undefined,
    });
  };

  const selectCategory = (c) => {
    setCategory(c);
    scrollToSection("products");
  };

  return (
    <div className="min-h-screen bg-cream font-body text-charcoal">
      <Header cartCount={cart.count} onOpenCart={() => setCartOpen(true)} />
      <main>
        <Hero />
        <Categories onSelect={selectCategory} />
        <About />
        <Products
          category={category}
          condition={condition}
          onCategoryChange={setCategory}
          onConditionChange={setCondition}
          onView={setActiveProduct}
          onAdd={addToCart}
        />
        <HowToOrder />
        <Contact />
      </main>
      <Footer />
      <ProductModal
        product={activeProduct}
        onClose={() => setActiveProduct(null)}
        onAdd={addToCart}
      />
      <CartDrawer open={cartOpen} onOpenChange={setCartOpen} cart={cart} />
      <FloatingWhatsApp />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
